import React, { createContext, useContext, ReactNode } from 'react';

interface AppContextType {
  // Aggiungi qui le proprietà del contesto dell'app se necessarie
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const value = {
    // Aggiungi qui i valori del contesto se necessari
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
